import { useEffect, useState } from "react";
import { Youtube, CheckCircle2, Circle } from "lucide-react";
import api from "../api";
import { CycleCalendar } from "../components/CycleCalendar";

export default function ProgramPage() {
  const [bloc, setBloc] = useState("A");
  const [view, setView] = useState("programme");
  const [calendar, setCalendar] = useState([]);
  const [program, setProgram] = useState([]);
  const [blocs, setBlocs] = useState([{ bloc: "A" }, { bloc: "B" }]);

  useEffect(() => {
    api.get("/blocs").then(({ data }) => { if (data.length > 0) setBlocs(data); }).catch(() => {});
  }, []);

  useEffect(() => {
    api.get("/program", { params: { bloc } }).then(({ data }) => setProgram(data));
  }, [bloc]);

  useEffect(() => {
    if (view === "calendrier") api.get("/calendar").then(({ data }) => setCalendar(data));
  }, [view]);

  const jours = ["Jour 1", "Jour 2", "Jour 3", "Jour 4"];
  const titres = { "Jour 1": "Pectoraux · Dos", "Jour 2": "Jambes complètes", "Jour 3": "Biceps · Triceps · Épaules", "Jour 4": "Repos actif" };

  return (
    <div className="pb-28">
      <header className="sticky top-0 z-30 backdrop-blur-xl bg-black/85 border-b border-[#2E2E3A] px-4 pt-4 pb-3">
        <h1 className="font-display text-4xl text-white leading-none">PROGRAMME</h1>
        <p className="text-[#B0B0B4] text-xs mt-0.5">Cycle 4 jours · Alterne Bloc A / Bloc B</p>
        <div className="flex gap-1.5 mt-3">
          {[["programme", "PROGRAMME"], ["calendrier", "CALENDRIER 8 SEM."]].map(([v, l]) => (
            <button key={v} data-testid={`view-${v}-button`} onClick={() => setView(v)}
              className={`h-9 px-4 text-xs uppercase tracking-wider border transition-colors ${
                view === v ? "border-[#FF3B30] text-white bg-[#FF3B30]/10" : "border-[#2E2E3A] text-[#B0B0B4] hover:text-white"}`}>
              {l}
            </button>
          ))}
        </div>
        {view === "programme" && (
        <div className="flex flex-wrap gap-2 mt-2">
          {blocs.map((b) => (
            <button key={b.bloc} data-testid={`program-bloc-${b.bloc}-button`} onClick={() => setBloc(b.bloc)}
              className={`h-10 px-5 font-display text-xl whitespace-nowrap transition-colors ${
                bloc === b.bloc ? "bg-[#FF3B30] text-white" : "bg-[#14141A] text-[#B0B0B4] hover:text-white"}`}>
              BLOC {b.bloc}{b.label ? ` · ${b.label.toUpperCase()}` : ""}
            </button>
          ))}
        </div>
        )}
      </header>
      {view === "calendrier" ? (
        <main className="px-4 mt-4 space-y-4" data-testid="calendar-view">
          <CycleCalendar />
          <div className="bg-[#14141A] border border-[#2E2E3A] p-3 text-xs text-[#B0B0B4]">
            8 semaines = 14 cycles de 4 jours. Le bloc alterne A / B à chaque cycle. Les séances enregistrées sont cochées automatiquement.
          </div>
          {Array.from({ length: 14 }, (_, i) => i + 1).map((c) => {
            const slots = calendar.filter((s) => s.cycle === c);
            const nbDone = slots.filter((s) => s.done).length;
            return (
              <section key={c} data-testid={`cycle-${c}`}>
                <div className="flex items-center justify-between mb-1.5">
                  <h2 className="font-display text-xl text-white">CYCLE {c} <span className={slots[0]?.bloc === "A" ? "text-[#FF3B30]" : "text-[#ccc]"}>· BLOC {slots[0]?.bloc}</span></h2>
                  <span className={`text-[10px] font-mono ${nbDone === 4 ? "text-[#32D74B]" : "text-[#B0B0B4]"}`}>{nbDone}/4</span>
                </div>
                <div className="grid grid-cols-4 gap-px bg-white/10 border border-[#2E2E3A]">
                  {slots.map((s) => (
                    <div key={s.jour} className={`p-2 text-center ${s.done ? "bg-[#32D74B]/10" : "bg-[#14141A]"}`}>
                      {s.done
                        ? <CheckCircle2 size={16} className="text-[#32D74B] mx-auto" />
                        : <Circle size={16} className="text-[#444] mx-auto" />}
                      <p className="text-white text-[11px] font-medium mt-1">{s.jour}</p>
                      <p className="text-[#B0B0B4] text-[9px] leading-tight mt-0.5">{s.done ? s.date : s.contenu}</p>
                    </div>
                  ))}
                </div>
              </section>
            );
          })}
        </main>
      ) : (
      <main className="px-4 mt-4 space-y-6">
        <div className="bg-[#14141A] border border-[#2E2E3A] p-4 text-sm text-[#ccc] space-y-1">
          <p className="font-display text-xl text-[#FF3B30]">LA RÈGLE D'OR</p>
          <p>Chaque série va à l'ÉCHEC · PLUS DE 10 répétitions.</p>
          <p className="text-[#B0B0B4] text-xs">&lt; 10 reps → baisse la charge · &gt; 20 reps → monte la charge.</p>
        </div>
        {jours.map((j) => {
          const rows = program.filter((p) => p.jour === j);
          return (
            <section key={j}>
              <h2 className="font-display text-2xl text-white mb-2">{j.toUpperCase()} <span className="text-[#B0B0B4] text-sm font-sans normal-case tracking-normal">— {titres[j]}</span></h2>
              <div className="bg-[#14141A] border border-[#2E2E3A] divide-y divide-white/5">
                {rows.map((ex) => (
                  <div key={ex.exercice + ex.ordre} className="px-4 py-2.5 flex items-center gap-3">
                    {ex.picto_url && (
                      <img src={`${process.env.REACT_APP_BACKEND_URL}${ex.picto_url}`} alt={ex.exercice}
                        className="w-11 h-11 object-cover bg-white shrink-0 border border-[#2E2E3A]" />
                    )}
                    <div className="flex-1 min-w-0">
                      <p className="text-white text-sm font-medium truncate flex items-center gap-1.5">
                        <span className="truncate">{ex.exercice}</span>
                        {ex.video_url && (
                          <a data-testid={`program-video-${ex.ordre}-${ex.jour.slice(-1)}`} href={ex.video_url} target="_blank" rel="noreferrer"
                            className="text-[#B0B0B4] hover:text-[#FF3B30] transition-colors shrink-0"><Youtube size={14} /></a>
                        )}
                      </p>
                      <p className="text-[#B0B0B4] text-xs">{ex.groupe} · {ex.muscle} · {ex.equipement}</p>
                    </div>
                    <div className="text-right shrink-0">
                      <p className="text-white text-xs font-mono">{ex.series > 1 ? `${ex.series} séries` : ex.objectif}</p>
                      {ex.repos_s > 0 && <p className="text-[#B0B0B4] text-[10px]">repos {ex.repos_s}s</p>}
                    </div>
                  </div>
                ))}
              </div>
            </section>
          );
        })}
      </main>
      )}
    </div>
  );
}
